export let filesDataContainer = null

export const setFilesData = data => {
  filesDataContainer = data
}
